import Cookies from "js-cookie";
import { clearAuthSession } from "./authSession";

const StatusValidation = response => {
	switch (response.status) {
		case 200:
		case 202:
			return response.json();
		case 401:
			// alert('Login session expired!');
			localStorage.clear();
			clearAuthSession();
			Cookies.remove('_cb_search_token');
			window.location = "/user/logout";
			// Return a resolved promise to prevent undefined in promise chain
			// This prevents white screen crashes when session expires
			return Promise.resolve({ 
				status: 'auth_error', 
				message: 'Session expired - redirecting to logout',
				redirected: true 
			});
		case 403:
			//alert('Login session expired!');
			localStorage.clear();
			clearAuthSession();
			Cookies.remove('_cb_search_token');
			window.location = "/user/logout";
			// Return a resolved promise to prevent undefined in promise chain
			// This prevents white screen crashes when access is forbidden
			return Promise.resolve({ 
				status: 'auth_error', 
				message: 'Access forbidden - redirecting to logout',
				redirected: true 
			});
		case 422:
			return (response.json().then((result) => {
				return {
					status: 'server_error',
					message: result,
				}
			}));
		case 400:
			return (response.json().then((result) => {
				return {
					status: 'api_error',
					message: result,
				}
			}));
		case 404:
			return (response.json().then((result) => {
				return {
					status: 'not_found_error',
					message: result
				}
			}))
		case 500:
		case 520:
			return (response.json().then((result) => {
				return {
					status: 'application_error',
					message: result,
				}
			}));
		default:
			return "Invalid";
	}
};

export default StatusValidation;